import { reducer as userSessionReducer } from "@talentech/bff-login";
import { combineReducers } from "redux";
import { feedbackApi } from "./feedback.api";

const reducer = combineReducers({
  userSession: userSessionReducer,
  feedbackApi: feedbackApi.reducer,
});

export default reducer;
